import * as React from "react";
import * as moment from "moment";
import {Renewal, resourcesHelper, PREMIUM_TYPE_ANNUAL, ProductsEnum} from "@falcon/services";


interface IProps {
    renewalProposal?: Renewal;
    product: ProductsEnum;
    productContent: React.ReactNode;
    monthlyInstalmentsAllowed: boolean;
}

// Banner in header to inform that policy will be renewed
export class PolicyWillBeRenewedBanner extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    public render(): React.ReactNode {
        const pendingRenewalDate: moment.Moment = moment.utc(this.props.renewalProposal?.headerInfo.startDate, moment.ISO_8601);
        const productWording: string = this.props.product === ProductsEnum.WOLF_MOTOR ?
            `${resourcesHelper.PRODUCT} Car Insurance policy` : `${resourcesHelper.PRODUCT} Home Insurance policy`;

        return (
            <div className="banner pending-renewal-banner">
                <img src={`/${resourcesHelper.THEME}/img/Flow-info.svg`} alt="Blue info icon"/>
                <div className="banner-text">
                    <p>
                        Rest easy - your {productWording} for{' '}
                        <strong>{this.props.productContent} is scheduled to renew on {pendingRenewalDate.format("D MMMM YYYY, 00:00")}.</strong>{' '}
                        No payment will be taken until then.
                    </p>
                    {this.props.renewalProposal?.factors.premiumType === PREMIUM_TYPE_ANNUAL && this.props.monthlyInstalmentsAllowed && <p>Monthly instalments are available at additional cost.</p>}
                </div>
            </div>
        );
    }
}
